export function mainBannerSlider() {
    let slider = $(".banner-slider");

    if (slider.find('iframe').length) {
        let firstVideo = new Vimeo.Player(slider.find('iframe'));
        firstVideo.pause();
        firstVideo.setVolume(1);
    }

    function videoActions() {
        let video = slider.find('.slick-current').find('iframe');
        if (video.length) {
            let player = new Vimeo.Player(video);
            $('.play-video').removeClass('hide');
            $('.stop-video').addClass('hide');
            player.pause();
            player.setVolume(1);
            $('.mute-video').addClass('pushed');
        }
    }

    slider.slick({
        dots: true,
        fade: true,
        arrows: false,
        speed: 1000,
        autoplaySpeed: 5000,
        infinite: true,
        adaptiveHeight: true
    }).on('beforeChange', function () {
        videoActions();
    }).on('afterChange', function () {
        videoActions();
    });

    slider.find('.slide-item-inner button').on('click', function () {
        let $this = $(this);
        let parent = $(this).closest('.slide-item-inner');
        let btnPlay = parent.find('.play-video');
        let btnStop = parent.find('.stop-video');
        let video = parent.find('iframe');
        if (video.length) {
            let player = new Vimeo.Player(video);
            //play
            if ($this.hasClass('play-video')) {
                player.play();
                btnPlay.addClass('hide');
                btnStop.removeClass('hide');
            }
            //stop
            if ($this.hasClass('stop-video')) {
                player.pause();
                btnPlay.removeClass('hide');
                btnStop.addClass('hide');
            }
            //mute
            if ($this.hasClass('mute-video')) {
                if (!$this.hasClass('pushed')) {
                    $this.addClass('pushed');
                    player.setVolume(1);
                } else {
                    $this.removeClass('pushed');
                    player.setVolume(0);
                }
            }
        }
    });

    function checkImagesforMobile() {
        let $slideImages = $('.slide-image');
        let $slideBgImages = $('.slide-bg-image');

        if (slider.hasClass('mob-device') && ($slideImages.length || $slideBgImages.length)) {
            let widthDevice = window.innerWidth;
            let heightDevice = window.innerHeight;

            $slideImages.each(function () {
                let $this = $(this);
                let imageSrc = (widthDevice > heightDevice) ? $this.attr('data-src-desk') : $this.attr('data-src-mob');
                $this.attr('src', imageSrc);
            });

            $slideBgImages.each(function () {
                let $this = $(this);
                let imageSrc = (widthDevice > heightDevice) ? $this.attr('data-src-desk') : $this.attr('data-src-mob');
                $this.css('background-image', `url(${imageSrc})`);
            });
        }
    }

    checkImagesforMobile();

    window.addEventListener("resize", () => {
        checkImagesforMobile();
    });

    return {
        sliderPlay: function () {
            slider.slick("slickSetOption", "autoplay", false, true);
        }
    };
}


// WEBPACK FOOTER //
// ./assets/js/modules/mainBannerSlider.js